import { Toggle } from './styles'

const Component = ({ onClick, children, ...rest }: any) => {
  return <Toggle type='button' onClick={onClick} {...rest}>{children}</Toggle>
}

export default Component
